/**
 * FormTemplateType.ts
 *
 * An enum for the types of forms available.
 */

export enum FormTemplateType {
	Single = 0,
	Basic = 1,
	FeedbackPortalIdea = 2,
}
